import { message } from 'antd';
import includes from 'lodash/includes';
import i18n from '~settings/i18n';
import { pmsEndpoints } from '~settings/endpoints';
import * as queries from '~settings/pms-queries';
import { fetch } from '~actions/pms-actions/shared';
import { pendingApprovalActionTypes as actions } from '~constants/actionTypes';

export const setPendingApprovalList = payload => ({
  type: actions.SET_PENDING_APPROVAL_LIST,
  payload: payload.pendingApproveList,
});

export const getPendingApprovalList =
  (successCallback = () => {}) =>
  dispatch => {
    fetch({
      dispatch,
      endpoint: pmsEndpoints.defaultUrl.url(),
      params: queries.pendingApprovalList(),
      communicationType: actions.GET_PENDING_APPROVAL_LIST_CS,
      successAction: setPendingApprovalList,
      onSuccess: () => {
        successCallback();
      },
      onError: () => {
        message.error(i18n.t('cms:cms.properties.edit.toast.error'));
      },
    });
  };

export const setPropertyComments = payload => ({
  type: actions.SET_PROPERTY_COMMENTS,
  payload: payload.property,
});

export const getPropertyComments =
  (slug, successCallback = () => {}) =>
  dispatch => {
    fetch({
      dispatch,
      endpoint: pmsEndpoints.getPropertyComments.url(),
      params: queries.getPropertyComments({ slug }),
      communicationType: actions.GET_PROPERTY_COMMENTS_CS,
      successAction: setPropertyComments,
      onSuccess: res => {
        successCallback(res);
      },
      onError: e => {
        if (e && e[0] && e[0].message === 'invalid node id.') {
          message.error(i18n.t('cms:cms.properties.edit.toast.error.property_not_exist'));
        } else {
          message.error(i18n.t('cms:cms.properties.edit.toast.error'));
        }
      },
    });
  };

export const requestPublish =
  (
    propertyId,
    successCallback = () => {},
    validateErrCallback = () => {},
    inativeErrorCallback = () => {},
  ) =>
  dispatch => {
    fetch({
      dispatch,
      endpoint: pmsEndpoints.requestPublish.url(),
      params: queries.requestPublish({ id: propertyId }),
      communicationType: actions.REQUEST_PUBLISH_CS,
      onSuccess: res => {
        if (res?.requestPublish?.error) {
          message.error(
            res?.requestPublish?.description || i18n.t('cms:cms.properties.edit.toast.error'),
          );
        } else {
          successCallback(res);
        }
      },
      onError: (errors, code) => {
        if (
          (errors &&
            errors[0] &&
            includes(
              ['VALIDATE_PAYMENT_PLAN_FAIL', 'INVALID_PROPERTY_PAYOUT_METHOD'],
              errors[0].message,
            )) ||
          (code && includes(['VALIDATE_PAYMENT_PLAN_FAIL', 'INVALID_PROPERTY_PAYOUT_METHOD'], code))
        ) {
          validateErrCallback(code || errors[0].message);
        } else if (code && includes(['PAYMENT_PLAN_NOT_ACTIVE'], code)) {
          inativeErrorCallback();
        } else if (errors?.[0]?.extensions?.code === 'LISTING_AVAILABILITY_SET_TO_NULL') {
          message.error(i18n.t('cms:cms.properties.edit.publish.listing_error'));
        } else {
          message.error(errors[0]?.message || i18n.t('cms:cms.properties.edit.toast.error'));
        }
      },
    });
  };
